// The landing page's resolved theme, as ThemeToggle.vue marks it on <html>.
export const RESOLVED_ATTR = "data-landing-resolved";

export function isLandingDark() {
  return document.documentElement.getAttribute(RESOLVED_ATTR) === "dark";
}
